// define moment locale for short meridiem
import moment from 'moment'

moment.defineLocale('en-short', {
  parentLocale: 'en',
  /* */
  meridiem: function(hours, minutes, isLower) {
    if (hours > 11) {
      return isLower ? 'p' : 'P'
    } else {
      return isLower ? 'a' : 'A'
    }
  },
})
// force to use en local
moment.locale('en')
